/**
 * Action Types
 */
export const USER_DETAILS = 'USER/DETAILS'
export const USER_ACCOUNTS = 'USER/ACCOUNTS'
export const USER_USERS = 'USER/USERS'
export const SET_FEATURE_FLAGS = 'USER/SET_FEATURE_FLAGS'

export const FEATURE_FLAG_NAMES = ['profitability', 'signal-dashboard']

export const CONTAINER_KEYS = ['container', 'rootContainer']

export const CONTAINER_TO_GROUP = {
  container: 'subGroup',
  rootContainer: 'group'
}
